import type { UserFormAndFolderMeta } from '@cognitoforms/types/server-types/model/user-form-and-folder-meta';
import type { UserMeta } from '@cognitoforms/types/server-types/model/user-meta';
import type { OrganizationMeta } from '@cognitoforms/types/server-types/model/organization-meta';
import type { UserAndAdminFolderMetas } from '@cognitoforms/types/server-types/model/user-and-admin-folder-metas';
import type { GlobalStoreMeta } from '@cognitoforms/types/server-types/model/global-store-meta';
import { serviceRequest } from './service-request';
import type { PortalMeta } from '@cognitoforms/types/server-types/model/portal-meta';
import type { UserOrganizationMeta } from '@cognitoforms/types/server-types/model/user-organization-meta';

export function getUserMeta(): Promise<UserMeta> {
	return serviceRequest('svc/entity-meta/user', null, { method: 'GET' });
}

export function getOrganizationMeta(): Promise<OrganizationMeta> {
	return serviceRequest('svc/entity-meta/organization', null, { method: 'GET' });
}

export async function getFormMeta(formIds: string[]): Promise<UserFormAndFolderMeta> {
	return serviceRequest('svc/entity-meta/forms', { formIds }, { method: 'POST' });
}

export async function getArchivedForms(): Promise<UserFormAndFolderMeta> {
	return serviceRequest('svc/entity-meta/archived-forms', null, { method: 'GET' });
}

export async function getFolderMeta(folderIds: string[]): Promise<UserAndAdminFolderMetas> {
	return serviceRequest('svc/entity-meta/folders', { folderIds }, { method: 'POST' });
}

export async function getPortalMeta(): Promise<PortalMeta> {
	return serviceRequest('svc/entity-meta/portal', null, { method: 'GET' });
}

export async function getGlobalStore(): Promise<GlobalStoreMeta> {
	return serviceRequest('svc/entity-meta/initialize', null, { method: 'GET' });
}

export function getUserOrganizationsMeta(): Promise<Array<UserOrganizationMeta>> {
	return serviceRequest('svc/entity-meta/organizations', null, { method: 'GET' });
}